import { PracticeTestType } from "../../appsConfig";
import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRootStore } from "@/state/RootStore";
import { observer } from "mobx-react";
import SplashScreen from "./SplashScreen";
import { useIsMobileWeb } from "@/hooks/useIsMobileWeb";

const Home = observer(() => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const store = useRootStore();
  const isMobileWeb = useIsMobileWeb();

  const stateSelected = store.mainAppStore.selectedStateCode;
  const profileFetched = store.mainAppStore.profileSaved;

  useEffect(() => {
    if (isSignedIn) {
      if (profileFetched && !stateSelected && PracticeTestType.byState) {
        navigate("/exam-selection-standalone", { replace: true });
        return;
      }

      if (profileFetched) {
        navigate(isMobileWeb ? "/profile" : "/study", { replace: isMobileWeb });
      }
    }
  }, [isMobileWeb, isSignedIn, navigate, profileFetched, stateSelected]);

  return <SplashScreen />;
});

export default Home;
